import React from "react";

const AnimatedItem = ({children, className}) => {
    return (
        <div className={`animated-item ${className}`}>
            {children}
        </div>
    );
};

export default AnimatedItem;
